import { Column, Container, Row } from '@algbra/ui/components/Grid/Grid'
import Whitespace from '@algbra/ui/components/Whitespace/Whitespace'
import { resolveAsImage } from '@algbra/ui/resolvers'
import { GatsbyResolvedAsset } from '@algbra/ui/types/image'
import { GatsbyImage } from 'gatsby-plugin-image'
import styles from './WideImage.module.scss'

export type ZoneWideImageProps = {
  __typename: 'StrapiGQL_ComponentZonesWideImage'
  id: string
  image: GatsbyResolvedAsset
}

export default function ZoneWideImage({ id, image }: ZoneWideImageProps) {
  return (
    <div>
      <Whitespace type="md">
        <div className={styles.imageContainer}>
          <GatsbyImage
            image={resolveAsImage(image)}
            alt={'Cover'}
            imgClassName={styles.image}
            loading="lazy"
          />
        </div>
      </Whitespace>
    </div>
  )
}
